import _objectSpread from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import warning from 'warning';
import Feedback from './Feedback';
import FormContext from './FormContext';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var FormControl = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    type = _ref.type,
    size = _ref.size,
    htmlSize = _ref.htmlSize,
    id = _ref.id,
    className = _ref.className,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    _ref$isInvalid = _ref.isInvalid,
    isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
    plaintext = _ref.plaintext,
    readOnly = _ref.readOnly,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'input' : _ref$as,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "type", "size", "htmlSize", "id", "className", "isValid", "isInvalid", "plaintext", "readOnly", "as"]);
  var _useContext = useContext(FormContext),
    controlId = _useContext.controlId;
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-control');
  var classes;
  if (plaintext) {
    classes = _defineProperty({}, "".concat(bsPrefix, "-plaintext"), true);
  } else {
    var _classes2;
    classes = (_classes2 = {}, _defineProperty(_classes2, bsPrefix, true), _defineProperty(_classes2, "".concat(bsPrefix, "-").concat(size), size), _classes2);
  }
  process.env.NODE_ENV !== "production" ? warning(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, {
    type: type,
    size: htmlSize,
    ref: ref,
    readOnly: readOnly,
    id: id || controlId,
    className: classNames(className, classes, isValid && "is-valid", isInvalid && "is-invalid", type === 'color' && "".concat(bsPrefix, "-color"))
  }));
});
FormControl.displayName = 'FormControl';
export default Object.assign(FormControl, {
  Feedback: Feedback
});